import { useCallback, useMemo } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import { getIsDesc, getSortBy, getSortValue } from 'utils';
import { SortByForm, SORTING_ORDER } from 'models/Sort';
import { MULTI_SORT_SEPARATOR, SORT_PARAM_KEYWORD } from 'data/global';
import { INITIAL_VALUE } from '../components/MultiSortOptions/MultiSortOptions.component';

type UseMultiSortFormProps = {
  sortParam?: string;
  onDone?: () => void;
};

export default function useMultiSortForm(props: UseMultiSortFormProps) {
  const { sortParam = SORT_PARAM_KEYWORD, onDone } = props;

  const { params, setQueryParam } = useQueryParams();

  const sort = params[sortParam];

  const initialValues = useMemo(
    () => ({
      sortBy: sort
        ? sort.split(MULTI_SORT_SEPARATOR).map((el) => ({
            name: getSortBy(el),
            order: getIsDesc(el) ? SORTING_ORDER.Z_TO_A : SORTING_ORDER.A_TO_Z,
          }))
        : [INITIAL_VALUE],
    }),
    [sort],
  );

  const onSubmit = useCallback(
    ({ sortBy }: SortByForm) => {
      const newSort = sortBy
        .filter(({ name }) => name)
        .map(({ name, order }) =>
          getSortValue(name, order === SORTING_ORDER.Z_TO_A),
        )
        .join(MULTI_SORT_SEPARATOR);

      setQueryParam(sortParam, newSort);
      onDone?.();
    },
    [onDone, setQueryParam, sortParam],
  );

  return { initialValues, onSubmit };
}
